module.exports = __webpack_public_path__ + "img/14.3402a484.jpg";